import Model from "../../model"
import { ID, WebSourceFieldName } from "../../types"

import Command, { CommandName } from "../command"

export type SetWebSourceFieldCommandState = {
  id: ID
  field: WebSourceFieldName
  value: any
  captured?: {
    oldValue: any
  }
}

export default class SetWebSourceFieldCommand extends Command {
  name: CommandName = "set-web-source-field"
  state: SetWebSourceFieldCommandState

  constructor(state: SetWebSourceFieldCommandState) {
    super()
    this.state = state
    if (
      this.state.field == "name" ||
      this.state.field == "scannedName" ||
      this.state.field == "userProvidedName"
    ) {
      throw "Cannot set name field directly. Use SetWebSourceFieldsCommand instead."
    }
  }

  // Possible conflicts:
  //  - source might have been deleted (Cancel)
  //  - goal might have been deleted (Resolve, Cancel)
  resolveConflicts(model: Model): SetWebSourceFieldCommandState | null {
    if (!model.getSource(this.state.id)) return null
    if (this.state.field == "goalId" && !model.getGoal(this.state.value))
      return null
    return this.state
  }

  local(model: Model): any {
    this.state.captured = {
      oldValue: model.fetchSource(this.state.id)[this.state.field],
    }
    model.setSourceField(this.state.id, this.state.field, this.state.value)
    if (
      this.state.field === "status" &&
      this.state.captured.oldValue == "new" &&
      this.state.value == "read"
    ) {
      model.setSourceField(this.state.id, "lastReadAt", new Date())
    }
  }

  undo(): Command[] {
    if (!this.state.captured) throw new Error("No captured undo state")
    return [
      new SetWebSourceFieldCommand({
        id: this.state.id,
        field: this.state.field,
        value: this.state.captured.oldValue,
      }),
    ]
  }

  merge(previous: Command | undefined): Command | undefined {
    if (
      previous instanceof SetWebSourceFieldCommand &&
      this.state.id === previous.state.id &&
      this.state.field === previous.state.field &&
      this.timestamp - previous.timestamp < 5000
    ) {
      const merged = new SetWebSourceFieldCommand({
        id: this.state.id,
        field: this.state.field,
        value: this.state.value,
      })
      merged.state.captured = previous.state.captured
      return merged
    }
  }
}
